/* istanbul ignore file */

const cross = (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#00222C"
    strokeWidth={1.3}
  >
    <title>Close</title>
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 5l14 14M5 19L19 5" />
    </g>
  </svg>
);

export default cross;
